import React from "react";

const Shapes = () => (
	<>
		<svg
			className="absolute top-0 left-0 -z-10"
			width="62"
			height="62"
			viewBox="0 0 62 62"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0 62V0H62C62.0281 34.238 34.2662 62 0 62Z"
				fill="#FF6A35"
				fillOpacity="0.26"
			/>
		</svg>

		<svg
			className="absolute top-[20%] left-[5%] -z-10"
			width="49"
			height="40"
			viewBox="0 0 49 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M39.7007 19.7167C64.5265 24.2635 33.2736 43.5256 19.8503 39.4334C6.42703 35.3413 0 30.6059 0 19.7167C0 8.82747 8.8873 0 19.8503 0C30.8134 0 14.8749 15.1699 39.7007 19.7167Z"
				fill="#1DC9FF"
				fillOpacity="0.6"
			/>
		</svg>

		<svg
			className="absolute bottom-0 left-0 -z-10"
			width="100"
			height="301"
			viewBox="0 0 100 301"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M100 7.37581C100 3.30288 96.795 0 92.8428 0C88.8892 0 85.6856 3.30288 85.6856 7.37581H100ZM22.4316 235.974C18.4794 235.974 15.2744 239.275 15.2744 243.349C15.2744 247.422 18.4794 250.725 22.4316 250.725V235.974ZM-78.8428 320.248C-82.795 320.248 -86 323.551 -86 327.624C-86 331.699 -82.795 335 -78.8428 335V320.248ZM6.44099 264.17C6.44099 260.097 3.23743 256.794 -0.716209 256.794C-4.66842 256.794 -7.87341 260.097 -7.87341 264.17H6.44099ZM85.6856 7.37581V97.6368H100V7.37581H85.6856ZM85.6856 97.6368C85.6856 107.708 77.6867 115.966 67.6953 115.966V130.717C85.4809 130.717 100 115.969 100 97.6368H85.6856ZM67.6953 115.966C49.9067 115.966 35.3919 130.728 35.3919 149.058H49.7063C49.7063 138.981 57.7081 130.717 67.6953 130.717V115.966ZM35.3919 149.058V154.391H49.7063V149.058H35.3919ZM35.3919 154.391C35.3919 172.72 49.9067 187.483 67.6953 187.483V172.732C57.7081 172.732 49.7063 164.466 49.7063 154.391H35.3919ZM67.6953 187.483C77.6838 187.483 85.6856 195.747 85.6856 205.823H100C100 187.494 85.4852 172.732 67.6953 172.732V187.483ZM85.6856 205.823V211.728H100V205.823H85.6856ZM85.6856 211.728C85.6856 225.065 75.0972 235.974 61.9208 235.974V250.725C82.9 250.725 100 233.318 100 211.728H85.6856ZM61.9208 235.974H45.9016V250.725H61.9208V235.974ZM45.9016 235.974H22.4316V250.725H45.9016V235.974ZM-78.8428 335H-62.3655V320.248H-78.8428V335ZM-62.3655 335C-24.3722 335 6.44099 303.297 6.44099 264.17H-7.87341C-7.87341 295.134 -32.2623 320.248 -62.3655 320.248V335Z"
				fill="#FDB314"
				fillOpacity="0.32"
			/>
		</svg>

		<svg
			className="absolute bottom-0 left-1/2"
			width="90"
			height="81"
			viewBox="0 0 90 81"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M85.8436 9.44612L39.2469 77.0032L4.08537 2.92747L85.8436 9.44612Z"
				stroke="#4175DF"
				strokeOpacity="0.78"
				strokeWidth="4"
			/>
		</svg>

		<svg
			className="absolute bottom-0 right-0 -z-10"
			width="134"
			height="133"
			viewBox="0 0 134 133"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M66.9999 133C104.003 133 134 103.227 134 66.5C134 29.773 104.003 0 66.9999 0C29.9968 0 0 29.773 0 66.5C0 103.227 29.9968 133 66.9999 133Z"
				fill="#FF9100"
				fillOpacity="0.59"
			/>
		</svg>

		<svg
			className="absolute right-0 top-[10%]"
			width="149"
			height="255"
			viewBox="0 0 149 255"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g opacity="0.2">
				<path
					d="M29.9138 200.627C16.1542 200.627 5 211.61 5 225.159C5 238.709 16.1542 249.692 29.9138 249.692C43.6732 249.692 54.8275 238.709 54.8275 225.159V124.964"
					stroke="#4484AB"
					strokeWidth="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M82.5575 92.916C97.6331 92.916 109.854 80.6999 109.854 65.6317C109.854 50.5624 97.6331 38.3473 82.5575 38.3473C67.4819 38.3473 55.2607 50.5624 55.2607 65.6317C55.2607 80.6999 67.4819 92.916 82.5575 92.916Z"
					stroke="#34C69F"
					strokeWidth="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M82.7746 124.964C116.395 124.964 143.651 98.1094 143.651 64.9819C143.651 31.8548 116.395 5 82.7746 5C49.1538 5 21.8984 31.8548 21.8984 64.9819"
					stroke="#FDB314"
					strokeWidth="10"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg>

		<div className="absolute -top-[15%] -right-[15%] w-[600px] h-[600px] rounded-full bg-slate-100 dark:bg-slate-800 -z-20" />
	</>
);

const ShapeSeven = () => (
	<svg
		className="absolute top-0 left-0 lg:-left-[150px] -z-30"
		width="291"
		height="168"
		viewBox="0 0 291 168"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M80.926 5.72087C38.4338 6.50518 4.64517 42.1258 5.44169 85.2796C6.23821 128.433 41.3183 162.781 83.8105 161.997L285.424 158.275"
			stroke="#34C69F"
			strokeWidth="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const HeroHeader = () => {
	return (
		<header className="py-14 md:py-24 bg-white dark:bg-[#0b1727] text-zinc-900 dark:text-white relative overflow-hidden z-10">
			<Shapes />

			<div className="container px-4 mx-auto">
				<div className="grid grid-cols-12 gap-6 items-center">
					<div className="col-span-12 lg:col-span-7 xl:col-span-6 text-center lg:text-start mb-12 lg:mb-0">
						<h2 className="text-3xl font-bold leading-tight tracking-wide lg:text-7xl mb-6">
							Let's Reveal Something New!
						</h2>
						<div className="max-w-xl">
							<p className="text-[17px] leading-relaxed opacity-80 my-12">
								An activity that requires a person's mental or physical effort
								is work.If a person is trained for a certain type of job, they
								may have a job or profession which suits.
							</p>
						</div>
						<button className="py-3 px-8 font-medium text-white bg-blue-600 hover:bg-opacity-90 rounded-full">
							Schedule a free session
						</button>
					</div>
					<div className="col-span-12 lg:col-span-5 relative text-center">
						<ShapeSeven />

						<div className="relative">
							<img
								src="https://cdn.easyfrontend.com/pictures/hero/hero-6.png"
								alt=""
								className="max-w-full h-auto rounded-full mx-auto"
							/>
							<div className="absolute w-[500px] h-[500px] left-0 top-0 bg-slate-100 dark:bg-slate-800 rounded-full -z-20"></div>
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};

export default HeroHeader;

